/**
 * Lagerfeuer Desktop (Windows-App, apps/desktop): Download-Link und Erkennung.
 * Die App hängt in der Lagerfeuer-Ansicht „LagerfeuerDesktop/<Version>“ an den User-Agent (die Discord-Ansicht nicht);
 * ein Preload gibt es bewusst nicht (DECISIONS D35/D39).
 */

/** Stabiler Alias auf den neuesten Installer (pflegt scripts/desktop-release.sh, Caddy-Route /desktop/*). */
export const DESKTOP_DOWNLOAD_URL = '/desktop/Lagerfeuer-Desktop-Setup-latest.exe';

export function isDesktopApp(userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean {
  return /(?:^|\s)LagerfeuerDesktop\/\d/.test(userAgent);
}
